export default __webpack_public_path__ + "static/media/Do Kki.7bd981d5.jpg";